import { Pipe, PipeTransform } from '@angular/core';
import { prettyPrintJson } from 'pretty-print-json';

/**
 * Pipe puro — formatação JSON depende apenas do valor de entrada.
 */
@Pipe({
  name: '_json',
  pure: true,
  standalone: false,
})
export class JsonPipe implements PipeTransform {
  public transform(value: unknown): string {
    if (value === null || value === undefined) {
      return '';
    }
    return prettyPrintJson.toHtml(value, {});
  }
}
